import './styles.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { loadScriptConditionally } from 'Helpers/scripts';

export default class HubspotForm extends Component {
    static propTypes = {
        id: PropTypes.string.isRequired
    };
    static defaultProps = {};

    constructor(props) {
        super(props);
    }

    componentDidMount = () => {
        loadScriptConditionally("https://js.hsforms.net/forms/v2.js", typeof hbspt === 'undefined' || typeof hbspt.forms === 'undefined').then(() => {
            hbspt.forms.create({
                portalId: process.env.HUBSPOT.portalId,
                formId: this.props.id,
                target: `#hubspot-form-${this.props.id}`
            });
        });
    }

    render() {
        const { id } = this.props;

        return (
            <div className="component-hubspot-form">
                <div id={`hubspot-form-${id}`}></div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/public/hubspot/Form/index.js